import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HiDotsVertical, HiUser } from "react-icons/hi"; // npm install react-icons
import { MdPrint, MdShare, MdDeleteOutline } from "react-icons/md";
import styles from "./ActionMenu.module.css";
import { useNavigate } from "react-router-dom";
import { BiSolidUser, BiUserMinus } from "react-icons/bi";
import { FaUserPlus } from "react-icons/fa";

const ActionMenu = ({
  handlePromoteAsAssociate,
}: {
  handlePromoteAsAssociate: () => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const handleClick = (url: string) => {
    navigate(url);
  };

  return (
    <div className={styles.wrapper} ref={menuRef}>
      <button
        className={styles.trigger}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Actions"
      >
        <HiDotsVertical />
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, scale: 0.9, x: 10 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              exit={{ opacity: 0, scale: 0.9, x: 10 }}
              transition={{ duration: 0.15, ease: "easeOut" }}
              className={styles.menu}
            >
              {/* The Arrow Pointer */}
              <div className={styles.arrow} />

              <button
                className={styles.menuItem}
                onClick={() => handleClick("/customers/customer-details")}
              >
                <HiUser className={styles.icon} />
                Profile
              </button>

              <button
                className={styles.menuItem}
                onClick={handlePromoteAsAssociate}
              >
                <FaUserPlus className={styles.icon} />
                Promote as Associate
              </button>
              {/* <button
                className={styles.menuItem}
                onClick={() => handleClick("")}
              >
                <MdShare className={styles.icon} />
                Share
              </button> */}

              {/* <div className={styles.divider} /> */}

              {/* <button
                className={`${styles.menuItem} ${styles.delete}`}
                onClick={() => handleClick("")}
              >
                <MdDeleteOutline className={styles.icon} />
                Delete
              </button> */}
            </motion.div>
          )}
        </AnimatePresence>
      </button>
    </div>
  );
};

export default ActionMenu;
